import { openTextFileOnNative } from '@/utils/nativeAndroidFiles';

export function buildCsv(rows = []) {
  return rows
    .map((row) => row.map((cell) => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(','))
    .join('\n');
}

export async function exportCsvFile(rows, filename) {
  const csv = `\uFEFF${buildCsv(rows)}`;
  const mimeType = 'text/csv;charset=utf-8';

  try {
    if (await openTextFileOnNative(csv, filename, mimeType)) {
      return;
    }
  } catch (error) {
    console.error('Falha ao exportar CSV no app nativo, usando fallback web:', error);
  }

  const blob = new Blob([csv], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
